import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {POIForm} from '../../../pages/client/poi/poi/model/poi.form';
import {POIService} from '../../../pages/client/poi/poi/poi.service';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {coordinatesValidator, emailValidator} from '../../validators';
import {NotificationService} from '../../notification/notification.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {SubscriptionUtils} from '../../commons/subscription.utils';

@Component({
  selector: 'app-poi-modal',
  templateUrl: './poi-modal.component.html',
  styleUrls: ['./poi-modal.component.scss'],
  providers: [POIService]
})

export class PoiModalComponent implements OnInit, OnDestroy {

  @Input()
  public poiFormEntry: POIForm;

  @Output()
  public saved = new EventEmitter<any>();

  public poiForm: UntypedFormGroup;
  public poiGroups = [];
  private subSubject = new Subject<boolean>();

  public constructor(private poiService: POIService,
                     private notification: NotificationService,
                     private modalService: NgbActiveModal,
                     private fb: UntypedFormBuilder) {
  }

  public ngOnInit(): void {
    this.setupPoiForm(this.poiFormEntry);
    this.getPoiGroups();
  }

  private setupPoiForm(form: POIForm): void {
    this.poiForm = this.fb.group({
        poiGroupId: [null, Validators.required],
        name: [null, Validators.compose([Validators.required, Validators.maxLength(255)])],
        address: [form.address, Validators.maxLength(255)],
        coordinates: [form.coordinates, Validators.compose([Validators.required, coordinatesValidator])],
        placeId: [null],
        comment: [null, Validators.maxLength(255)],
        favorite: false
      }
    );
  }

  private getPoiGroups(): void {
    this.poiService.poiGroups()
      .pipe(takeUntil(this.subSubject))
      .subscribe({
        next: (data) => this.poiGroups = data,
        error: () => this.notification.loadingError()
      });
  }

  public submit(valid: boolean): void {
    if (valid) {
      this.poiService.create(this.poiForm.value)
        .pipe(takeUntil(this.subSubject))
        .subscribe({
          next: () => {
            this.notification.savingSuccess();
            this.modalService.close(this.poiForm.value.name);
          },
          error: () => this.notification.storingError()
        });
    }
  }

  public close(): void {
    this.modalService.close();
  }

  public ngOnDestroy(): void {
    SubscriptionUtils.safeUnsubscribeSubject(this.subSubject);
  }
}
